import { PATH_AUTH } from "../routes/paths";
import axios from "../utils/axios";

function jwtDecode(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(""),
  );
  return JSON.parse(jsonPayload);
}

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

export const isImpersonationToken = (token) => {
  try {
    return jwtDecode(token)?.userType === "impersonation";
  } catch (error) {
    return false;
  }
};

let expiredTimer;

export const tokenExpired = (exp) => {
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;
  clearTimeout(expiredTimer);
  expiredTimer = setTimeout(() => {
    alert("Token expired");
    localStorage.removeItem("accessToken");
    window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    const { exp, isImpersonating } = jwtDecode(accessToken);
    if (!isImpersonating) tokenExpired(exp);
  } else {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("shiftEndTime");
    localStorage.removeItem("shiftStartTime");
    clearTimeout(expiredTimer);
    delete axios.defaults.headers.common.Authorization;
  }
};

export const setRefresh = (refreshToken) => {
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  } else {
    localStorage.removeItem("refreshToken");
  }
};

export const setWarehouseSelection = (selectionToken, warehouses) => {
  if (selectionToken) {
    localStorage.setItem("warehouseSelectionToken", JSON.stringify(selectionToken));
  } else {
    localStorage.removeItem("warehouseSelectionToken");
  }
  if (warehouses?.length) {
    localStorage.setItem("warehouses", JSON.stringify(warehouses));
  } else {
    localStorage.removeItem("warehouses");
  }
};

export const getWarehouseSelection = () => {
  try {
    return {
      selectionToken: JSON.parse(localStorage.getItem("warehouseSelectionToken")),
      warehouses: JSON.parse(localStorage.getItem("warehouses")) || [],
    };
  } catch (error) {
    return { selectionToken: null, warehouses: [] };
  }
};

export const setLevel = (levelSelected) => {
  if (levelSelected && levelSelected) {
    localStorage.setItem("levelSelected", JSON.stringify(levelSelected));
    localStorage.setItem("levelPopOver", levelSelected.id);
  } else {
    localStorage.removeItem("levelSelected");
    localStorage.removeItem("levelPopOver");
  }
};

// The backend returns the selection token as { token, expires }; select-warehouse expects the raw token.
export const getSelectionTokenValue = (selectionToken) => {
  if (typeof selectionToken === "string") return selectionToken;
  if (!selectionToken?.token) return null;
  if (selectionToken.expires && new Date(selectionToken.expires) <= new Date()) return null;
  return selectionToken.token;
};
